import React, { FC, SVGProps } from 'react';

const DoorIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="2" width="16" height="20" rx="1" stroke="currentColor" strokeWidth="2" />
      <line
        x1="4"
        y1="22"
        x2="20"
        y2="22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="15.5" cy="12" r="1" fill="currentColor" />
    </svg>
  );
};

export default DoorIcon;
